import * as Yup from 'yup'
import { objNameRoles } from '../../const/constRoles'

const RfcValidator =
  /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{3}))?$/

const userNameValidator = /^[a-zA-Z0-9]*$/

const contactsValidator = Yup.array().of(
  Yup.object().shape({
    contactName: Yup.string().required('Campo requerido'),
    paternalSurname: Yup.string().required('Campo requerido'),
    maternalSurname: Yup.string(),
    phone: Yup.string()
      .min(10, 'El número de teléfono debe ser a 10 dígitos')
      .max(10, 'El número de teléfono debe ser a 10 dígitos')
      .required('Campo requerido'),
    cell: Yup.string()
      .min(10, 'El número de teléfono debe ser a 10 dígitos')
      .max(10, 'El número de teléfono debe ser a 10 dígitos')
      .required('Campo requerido'),
    email: Yup.string().email('Email inválido').required('Campo requerido'),
  })
)

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Campo requerido'),
  RFC: Yup.string()
    .matches(RfcValidator, 'RFC inválido')
    .required('Campo requerido'),
  socialReason: Yup.string().required('Campo requerido'),
  direction: Yup.string().required('Campo requerido'),
  outdoorNumber: Yup.string().required('Campo requerido'),
  postalCode: Yup.string()
    .min(4, 'El CP debe ser mayor a 4 y menor a 6 dígitos')
    .max(6, 'El CP debe ser mayor a 4 y menor a 6 dígitos')
    .required('Campo requerido'),
  colonia: Yup.string().required('Campo requerido'),
  city: Yup.string().required('Campo requerido'),
  municipality: Yup.string().required('Campo requerido'),
  state: Yup.string().required('Campo requerido'),
  contacts: contactsValidator,
})

export const validationSchemaUser = Yup.object().shape({
  name: Yup.string().trim().required('El nombre es requerido'),
  userEmail: Yup.string()
    .trim()
    .email('El correo electrónico es invalido')
    .required('El correo electrónico es requerido'),
  password: Yup.string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .required('Este campo es obligatorio'),
  passwordConfirm: Yup.string()
    .required('Necesita confirmar la contraseña')
    .oneOf([Yup.ref('password'), null], 'La contraseña no coincide'),
  userPhone: Yup.string()
    .trim()
    .min(10, 'El número de teléfono debe ser a 10 dígitos')
    .max(10, 'El número de teléfono debe ser a 10 dígitos')
    .required('El teléfono es requerido'),
  userRole: Yup.string().required('Este campo es obligatorio'),
  avatar: Yup.string().required('Este campo es obligatorio'),
  charge: Yup.string().required('Este campo es obligatorio'),
  username: Yup.string().required('Este campo es obligatorio'),
  first_name: Yup.string().required('Este campo es obligatorio'),
  // provider_id: Yup.string().when('userRole', {
  //   is: (userRole) =>
  //     [objNameRoles.provedor_pipas, objNameRoles.chofer_pipas].includes(
  //       +userRole
  //     ),
  //   then: Yup.string().required('Este campo es obligatorio'),
  //   otherwise: Yup.string().nullable(),
  // }),
})

export const validationSchemaRegisterUser = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(5, 'El nombre debe tener al menos 5 caracteres')
    .max(100, 'El nombre debe tener como maximo 100 caracteres')
    .required('El nombre es requerido'),
  userEmail: Yup.string()
    .trim()
    .min(5, 'El correo electrónico debe tener al menos 5 caracteres')
    .max(50, 'El correo electrónico debe tener como maximo 200 caracteres')
    .email('El correo electrónico es invalido')
    .required('El correo electrónico es requerido'),
  password: Yup.string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .required('Este campo es obligatorio'),
  passwordConfirm: Yup.string()
    .required('Necesita confirmar la contraseña')
    .oneOf([Yup.ref('password'), null], 'La contraseña no coincide'),
  userPhone: Yup.string()
    .trim()
    .min(10, 'El número de teléfono debe ser a 10 dígitos')
    .max(10, 'El número de teléfono debe ser a 10 dígitos')
    .required('El teléfono es requerido'),
  address: Yup.string()
    .trim()
    .min(5, 'La dirección debe tener al menos 5 caracteres')
    .max(200, 'La dirección debe tener como maximo 200 caracteres')
    .required('La dirección es requerida'),
})

export const validationSchemaUserUpdatePassword = Yup.object().shape({
  name: Yup.string().trim().required('Este campo es requerido'),
  userEmail: Yup.string()
    .trim()
    .email('Email inválido')
    .required('Este campo es requerido'),
  password: Yup.string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .required('Este campo es obligatorio'),
  passwordConfirm: Yup.string()
    .required('Necesita confirmar la contraseña')
    .oneOf([Yup.ref('password'), null], 'La contraseña no coincide'),
  userPhone: Yup.string()
    .trim()
    .min(10, 'El número de teléfono debe ser a 10 dígitos')
    .max(10, 'El número de teléfono debe ser a 10 dígitos')
    .required('Este campo es requerido'),
  userRole: Yup.string().required('Este campo es obligatorio'),
  charge: Yup.string().required('Este campo es obligatorio'),
})

export const validationSchemaUserUpdate = Yup.object().shape({
  name: Yup.string().trim().required('Este campo es requerido'),
  userEmail: Yup.string()
    .trim()
    .email('Email inválido')
    .required('Este campo es requerido'),
  userPhone: Yup.string()
    .trim()
    .min(10, 'El número de teléfono debe ser a 10 dígitos')
    .max(10, 'El número de teléfono debe ser a 10 dígitos')
    .required('Este campo es requerido'),
  userRole: Yup.string().required('Este campo es obligatorio'),
  charge: Yup.string().required('Este campo es obligatorio'),
  username: Yup.string().required('Este campo es obligatorio'),
})

export const passwordValidator = Yup.object().shape({
  currentPassword: Yup.string().required('Este campo es requerido'),
  password: Yup.string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .required('Campo requerido'),
  passwordConfirm: Yup.string()
    .required('Necesita confirmar la contraseña')
    .oneOf([Yup.ref('password'), null], 'La contraseña no coincide'),
})

export const commodityReceiptValidator = Yup.object().shape({
  quantity: Yup.number().required('Campo requerido'),
})

export const validationSchemaUserAppOperator = Yup.object().shape({
  name: Yup.string().required('Campo requerido'),
  firstName: Yup.string().required('Campo requerido'),
  lastName: Yup.string(),
  userName: Yup.string()
    .matches(
      userNameValidator,
      'El nombre de usuario sólo puede contener letras y números, sin espacios'
    )
    .required('Campo requerido'),
  userEmail: Yup.string().email('Email inválido').required('Campo requerido'),
  password: Yup.string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .required('Campo requerido'),
  passwordConfirm: Yup.string()
    .required('Necesita confirmar la contraseña')
    .oneOf([Yup.ref('password'), null], 'La contraseña no coincide'),
  direction: Yup.string().required('Campo requerido'),
  outdoorNumber: Yup.string().required('Campo requerido'),
  postalCode: Yup.string()
    .min(4, 'El CP debe ser mayor a 4 y menor a 6 dígitos')
    .max(6, 'El CP debe ser mayor a 4 y menor a 6 dígitos')
    .required('Campo requerido'),
  colonia: Yup.string().required('Campo requerido'),
  city: Yup.string().required('Campo requerido'),
  municipality: Yup.string().required('Campo requerido'),
  state: Yup.string().required('Campo requerido'),
  contacts: contactsValidator,
  avatar: Yup.string().required('Campo requerido'),
  warehouse_id: Yup.string(),
  id_vehicle: Yup.string().required('Campo requerido'),
})

export const validationSchemaUserAppOperatorUpdate = Yup.object().shape({
  name: Yup.string().required('Campo requerido'),
  firstName: Yup.string().required('Campo requerido'),
  lastName: Yup.string(),
  userEmail: Yup.string().email('Email inválido').required('Campo requerido'),
  userName: Yup.string()
    .matches(
      userNameValidator,
      'El nombre de usuario sólo puede contener letras y números, sin espacios'
    )
    .required('Campo requerido'),
  direction: Yup.string().required('Campo requerido'),
  outdoorNumber: Yup.string().required('Campo requerido'),
  postalCode: Yup.string()
    .min(4, 'El CP debe ser mayor a 4 y menor a 6 dígitos')
    .max(6, 'El CP debe ser mayor a 4 y menor a 6 dígitos')
    .required('Campo requerido'),
  colonia: Yup.string().required('Campo requerido'),
  city: Yup.string().required('Campo requerido'),
  municipality: Yup.string().required('Campo requerido'),
  state: Yup.string().required('Campo requerido'),
  warehouse_id: Yup.string(),
  id_vehicle: Yup.string().required('Campo requerido'),
  // .notRequired()
  // .when('userRole', {
  //   is: (val) => val === '3',
  //   then: Yup.string().required('Campo requerido'),
  //   otherwise: Yup.string().notRequired(),
  // }),
  contacts: contactsValidator,
  avatar: Yup.string().required('Campo requerido'),
})
